import {
  __export
} from "./chunk-IEP6GGEX.mjs";

// src/SqlMigrations.ts
var SqlMigrations_exports = {};
__export(SqlMigrations_exports, {
  apply: () => apply,
  splitStatements: () => splitStatements
});
import * as SqlClient from "@effect/sql/SqlClient";
import * as Effect from "effect/Effect";
var TOKEN = /'(?:[^']|'')*'|"(?:[^"]|"")*"|--[^\n]*|\/\*[\s\S]*?\*\/|;/g;
var splitStatements = (script) => script.replace(TOKEN, (token) => token === ";" ? "\0" : token.startsWith("--") ? "" : token.startsWith("/*") ? " " : token).split("\0").map((statement) => statement.trim()).filter((statement) => statement.length > 0);
var apply = (...scripts) => Effect.gen(function* () {
  const sql = yield* SqlClient.SqlClient;
  for (const script of scripts) {
    for (const statement of splitStatements(script)) {
      yield* sql`${sql.literal(statement)}`;
    }
  }
});

export {
  splitStatements,
  apply,
  SqlMigrations_exports
};
//# sourceMappingURL=chunk-GQ4P5YGI.mjs.map
